import React, { useState, createContext, useContext } from 'react';
import { Language, translations } from '../lib/translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: typeof translations.es;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('es');
  const value = {
    language,
    setLanguage,
    t: translations[language]
  };
  return <LanguageContext.Provider value={value} data-id="element-253">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}